import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor(private tss:AuthService){}
  openTextHeaders(): HttpHeaders{
    return new HttpHeaders({ 'Content-Type': 'text/plain','Authorization':`Bearer ${this.tss.getToken()}`});
  }

  openPdfHeaders(): HttpHeaders{
    return new HttpHeaders({ 'Content-Type': 'application/pdf','Authorization':`Bearer ${this.tss.getToken()}`});
  }

  openJsonHeaders(): HttpHeaders{
    return new HttpHeaders({ 'Content-Type': 'application/json','Authorization':`Bearer ${this.tss.getToken()}`})
  }
  bearerTextHeaders(): HttpHeaders{
    return new HttpHeaders({ 'Content-Type': 'text/plain', 'Authorization':`Bearer ${this.tss.getToken()}`})
  }
  bearerJsonHeaders(): HttpHeaders{
    return new HttpHeaders({ 'Content-Type': 'application/json','Authorization':`Bearer ${this.tss.getToken()}`})
  }

  bearerFormHeaders(): HttpHeaders{
    return new  HttpHeaders({ 'Authorization':`Bearer ${this.tss.getToken()}`,'Content-Type': 'application/x-www-form-urlencoded' } )
  }
  openFormHeaders(): HttpHeaders{
    return new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded','Authorization':'' } )
  }
  bearerFormMultipartHeaders(): HttpHeaders{
    return new HttpHeaders({'Authorization':`Bearer ${this.tss.getToken()}` } )
  }

}

